// extracted by css-extract-rspack-plugin
export default {"originalQuery":"original-query--ebZZLmo4c8qHAeWz"};